export default "__VITE_ASSET__Dk9daQm6__"